import React, { useEffect, useState } from 'react'
import TextNavTitle from '../../../components/TextNavTitle'
import NavTitle from '../../../components/nav-title'
import CardCustom from '../../../components/custom/card-custom'
import { Button, Col, Form, Row, Table } from 'react-bootstrap'
import { PaginationControl } from 'react-bootstrap-pagination-control'
import { FaPlus } from 'react-icons/fa6'
import { useSelector } from 'react-redux'
import { listIncomeAPI } from '../../../services/income/payment'
import { Controller, useForm } from 'react-hook-form'
import NavRoleOrg from '../../../components/nav-role-org'
import { fnDateEn } from '../../../helper/fnDateEn'
import InputSearchCustom from '../../../components/custom/InputSearchCustom'
import styled from 'styled-components'
import CustomDatePicker from '../../../components/custom/CustomDatePicker'
import TableSkeletonBody from '../../../components/custom/TableSkeletonBody'
import { BsPencilSquare } from 'react-icons/bs'
import ModalUpdateDeduction from './ModalNewImportIncome'
import Error_false from '../../../components/error/error-false'

export default function DeductionsPage() {
  const orgId = useSelector((state) => state.roleReducer.role)
  const totalLimits = 20
  const [totalRows, setTotalRow] = useState(0)
  const [page, setPage] = useState(1)
  const [dataTable, setDataTable] = useState([])
  const [bodyFilter, setBodyFilter] = useState()
  const [isLoading, setIsLoading] = useState(true)
  const [selectMonth, setSelectMonth] = useState(new Date())

  const [showModal, setShowModal] = useState({ isShow: false, data: null })
  useEffect(() => {
    const body = {
      ...bodyFilter,
      page: 1,
      orgId,
      paymentListTypeId: 2,
      paymentPeriodDate: fnDateEn(selectMonth).format('YYYYMM')
    }
    if (orgId) {
      fnGetData(body)
    }
  }, [orgId])

  const fnGetData = async (body) => {
    setIsLoading(true)
    setBodyFilter(body)
    setPage(body.page)
    const resp = await listIncomeAPI(body)
    setIsLoading(false)
    if (!resp) return
    if (resp.status) {
      setDataTable(resp.result)
      setTotalRow(resp.totalRows)
    } else {
      Error_false(resp)
      setTotalRow(0)
      setDataTable([])
    }
  }

  const { control, handleSubmit } = useForm({})
  const onClearSearch = () => {
    const body = {
      ...bodyFilter,
      page: 1,
      searchs: ''
    }
    fnGetData(body)
  }
  const onSearch = (d) => {
    const body = {
      ...bodyFilter,
      page: 1,
      searchs: d.search
    }
    fnGetData(body)
  }
  return (
    <>
      <NavTitle>
        <TextNavTitle>รายหัก</TextNavTitle>
      </NavTitle>
      <NavRoleOrg />
      <CardCustom className="d-flex justify-content-between ">
        <div>
          <div className="p-3 ">
            <Row>
              <Col md={4} className="my-auto">
                <label className="small">
                  Total: {totalRows.toLocaleString()}
                </label>
              </Col>

              <Col md={8} className="text-end">
                <BoxFilter className="justify-content-end">
                  <Form
                    className="from-search"
                    onSubmit={handleSubmit(onSearch)}
                  >
                    <Controller
                      name={'search'}
                      control={control}
                      render={({ field: { onChange, value = '' } }) => (
                        <InputSearchCustom
                          value={value}
                          onChange={(d) => {
                            onChange(d)

                            if (!d) {
                              onClearSearch()
                            }
                          }}
                          placeholder="Search"
                        />
                      )}
                    />
                  </Form>
                  <div style={{ minWidth: 180 }}>
                    <CustomDatePicker
                      value={selectMonth}
                      showYearDropdown
                      isClearable={false}
                      placeholderText="Periods"
                      // renderMonthContent={renderMonthContent}
                      showMonthYearPicker
                      dateFormat="MM/yyyy"
                      onChange={(d) => {
                        if (d) {
                          const body = {
                            ...bodyFilter,
                            page: 1,
                            paymentPeriodDate: fnDateEn(d).format('YYYYMM')
                          }
                          fnGetData(body)
                        } else {
                          const body = {
                            ...bodyFilter,
                            page: 1,
                            paymentPeriodDate: ''
                          }
                          fnGetData(body)
                        }
                        setSelectMonth(d)
                      }}
                    />
                  </div>
                  <Button
                    className="px-4"
                    onClick={() => {
                      setShowModal({ isShow: true, data: null })
                    }}
                  >
                    <FaPlus className="me-2" />
                    Add
                  </Button>
                </BoxFilter>
              </Col>
            </Row>
          </div>
          <Table hover>
            <thead
              className="bg-hrms text-white "
              style={{ position: 'sticky', top: '0px' }}
            >
              <tr className="font-title-table">
                <th className="fw-normal ">#</th>

                <th className="fw-normal ">Periods</th>
                <th className="fw-normal ">Code</th>
                <th className="fw-normal">Name</th>
                <th className="fw-normal">Payment</th>
                <th className="fw-normal text-end">Amount</th>
                <th className="fw-normal ">Type</th>
                <th className="fw-normal text-center">Action</th>
              </tr>
            </thead>
            <tbody className="text-break fw-light">
              {isLoading ? (
                <TableSkeletonBody colSpan={8} rowSpan={7} />
              ) : dataTable.length > 0 ? (
                dataTable.map((d, i) => (
                  <tr className="font-small-2 align-middle" key={i}>
                    <td> {page * totalLimits - totalLimits + i + 1}</td>
                    <td className="">
                      {fnDateEn(d.paymentPeriodDate).format('MM/YYYY')}
                    </td>
                    <td className="">{d.code}</td>
                    <td className="">
                      {d.titleTh}
                      {d.nameTh} {d.surnameTh}
                    </td>
                    <td className="">{d.paymentName}</td>

                    <td className="text-end">
                      {d.paymentAmounts?.toLocaleString()}
                    </td>

                    <td className="">{d.dataTypeName}</td>

                    <td className="text-center">
                      <Button
                        size="sm"
                        variant="light"
                        className="text-primary shadow-sm"
                        onClick={() => {
                          setShowModal({ isShow: true, data: d })
                        }}
                      >
                        <BsPencilSquare />
                      </Button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr className="table-body">
                  <td colSpan={8} className="text-center">
                    -No Data-
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
        <div className="pt-3">
          <PaginationControl
            page={page}
            total={totalRows}
            limit={totalLimits}
            changePage={(p) => {
              const body = {
                ...bodyFilter,
                page: p
              }
              fnGetData(body)

              setPage(p)
            }}
            ellipsis={1}
          />
        </div>
      </CardCustom>

      {showModal.isShow && (
        <ModalUpdateDeduction
          data={showModal.data}
          orgId={orgId}
          fnGetData={() => fnGetData(bodyFilter)}
          onCancel={() => setShowModal({ isShow: false, data: null })}
          open={showModal.isShow}
        />
      )}
    </>
  )
}

const BoxFilter = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;

  .from-search {
    flex: 0 0 250px;
  }

  .btn-new {
    flex: 0 0 150px;
  }
`
